import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { TranslatePipe } from '@softline/ui-core';
import { FileViewComponent } from '@softline/ui-core/file-viewer';
import { ensureDocumentsTranslations } from '../documents.i18n';
import { pdfBlobFromBase64 } from './pdf-blob.function';

/** Renders a document's print preview (base64 PDF) through the shared file
 *  viewer, so the panel looks and behaves like the archive's viewer. The
 *  consumer loads the PDF (see `DocumentPreviewService`) and answers `reload`. */
@Component({
  selector: 'soft-document-preview',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FileViewComponent, TranslatePipe],
  templateUrl: './document-preview.component.html',
  styleUrl: './document-preview.component.css',
})
export class DocumentPreviewComponent {
  private readonly translationsReady = ensureDocumentsTranslations();

  readonly base64 = input<string | null>(null);
  readonly loading = input(false);
  /** Names the document in the viewer's meta line and in its download. */
  readonly fileName = input('');
  readonly reload = output<void>();

  /** The viewer takes the Blob directly, so no object URL is created and none
   *  has to be revoked. */
  readonly document = computed(() => {
    const base64 = this.base64();
    if (!base64) return null;
    try {
      return pdfBlobFromBase64(base64);
    } catch {
      return null;
    }
  });
}
